const TOKENKEY = "token";

// 方案一  sessionStorage
// const setToken = token => {
//   sessionStorage.setItem(TOKENKEY, token);
//   console.log("setToken", token);
// };
// const getToken = token => {
//   return sessionStorage.getItem(TOKENKEY, token);
// };
// const removeToken = token => {
//   sessionStorage.removeItem(TOKENKEY);
// };

//方案二  localStorage
const setToken = token => {
  localStorage.setItem(TOKENKEY, token);
};
const getToken = token => {
  return localStorage.getItem(TOKENKEY, token);
};
const removeToken = token => {
  localStorage.removeItem(TOKENKEY);
};

export { setToken, getToken, removeToken };